<template>
  <div class="layout" :class="{ 'layout--scrollable': $route.meta.isScrollable }">
    <avl-backdrop
      class="layout__backdrop"
      @click.native="$refs.sideMenu.hideSideMenu()"
    ></avl-backdrop>

    <avl-side-menu class="layout__side-menu" ref="sideMenu"></avl-side-menu>

    <avl-header class="layout__header"></avl-header>

    <div
      class="layout__content"
      :class="{
        'layout__content--chat-opened': getChatIsOpened,
        'layout__content--modal-opened': getModalIsOpened,
      }"
    >
      <!-- content -->
      <slot></slot>
    </div>

    <avl-footer class="layout__footer"></avl-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Header from './header';
  import Footer from './footer';
  import SideMenu from './side-menu';
  import Backdrop from './backdrop';

  export default {
    computed: {
      ...mapGetters('auth', ['isAuth']),
      ...mapGetters('layout', ['getChatIsOpened', 'getModalIsOpened']),
    },
    components: {
      'avl-header': Header,
      'avl-footer': Footer,
      'avl-side-menu': SideMenu,
      'avl-backdrop': Backdrop,
    },
  };
</script>

<style scoped lang="scss">
  .layout {
    background: url(../../assets/img/layout/background.png) no-repeat center fixed;
    background-size: cover;
    height: 100vh;
    width: 100%;
    overflow: hidden;

    &--scrollable {
      height: auto;
      min-height: 100vh;
    }

    &__header,
    &__footer {
      z-index: z('above-default');
    }

    &__backdrop,
    &__side-menu {
      z-index: z('side-menu');
    }

    &__content {
      position: relative;
      padding-top: $header-height * 1.15;
      //
      height: 100%;
      width: 100%;

      &--chat-opened {
        z-index: z('topmost');
        @include phone-lg() {
          z-index: z('default');
        }
      }

      &--modal-opened {
        z-index: z('topmost');
      }
    }
  }
</style>
